
// import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
import {createHashHistory} from 'history';
const hashHistory = createHashHistory();
// const routingStore = new RouterStore();
// const history = syncHistoryWithStore(hashHistory, routingStore);
export {hashHistory as history}
export default hashHistory;